
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { IInputMethodBehavior, InputMethodKinds } from "../../../../../../documaker/domain/format/objects";
import { IInputMethodBehaviorPropertyEditable, instanceOfIInputMethodBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";
import { StandardOption } from "../../../../../../base/components/system/selectors/mixins";

@Component
export default class InputMethodBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IInputMethodBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IInputMethodBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isInputMethodBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIInputMethodBehaviorPropertyEditable(s) && s.inputMethodBehavior().isEditable(), false);
  }

  get inputMethodBehavior(): IInputMethodBehavior {
    return this.readPropertyOrDefault(s => s.inputMethodBehavior().getValue(), { kind: InputMethodKinds.None});
  }

  set inputMethodBehavior(value: IInputMethodBehavior) {
    this.writePropertyWhenValid(s => s.inputMethodBehavior().setValue(value));
  }

  get inputMethods(): InputMethodKinds[] {
    return this.readPropertyOrDefault(s => s.getSelectableInputMethods(), []);
  }

  get inputMethodOptions(): StandardOption<InputMethodKinds>[] {
    return Enumerable.from(InputMethodBehaviorPropertyEditableMixin._inputMethodOptions)
      .where(o => 0 <= this.inputMethods.indexOf(o.value))
      .toArray();
  }

  private static readonly _inputMethodOptions: StandardOption<InputMethodKinds>[] = [
    new StandardOption<number>("設定しない", InputMethodKinds.None),
    new StandardOption<number>("数字", InputMethodKinds.HalfWidthNumberOnly),
    new StandardOption<number>("半角", InputMethodKinds.HalfWidthOnly),
    new StandardOption<number>("全角", InputMethodKinds.FullWidthOnly),
    new StandardOption<number>("英語", InputMethodKinds.HalfWidthAlphabetOnly),
  ];
}
